import PropTypes from 'prop-types'
import React from 'react'
import validator from 'validator'

import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

import PanelField from './PanelField'
import TeamPlayer from './TeamPlayer'

function leftJustify(str, length, char) {
  const fill = []
  while (fill.length + str.length < length) {
    fill[fill.length] = char
  }
  return fill.join('') + str
}

const styles = (theme) => ({
  heading: {
    backgroundColor: theme.palette.secondary.dark,
    color: '#ffffff',
  },
  headingTitle: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  content: {
    flex: 1,
  },
  field: {
    marginBottom: theme.spacing(1),
    wordBreak: 'break-word',
  },
  player: {
    display: 'flex',
    height: 768,
    [theme.breakpoints.down('md')]: {
      height: 512,
    },
    [theme.breakpoints.down('sm')]: {
      height: 384,
    },
    [theme.breakpoints.down('xs')]: {
      height: 256,
    },
  },
})
const useStyles = makeStyles(styles)

export default function TeamInfo(props) {
  const {
    authorizationToken,
    deckId,
    projectCategory,
    projectMadlib,
    recordingId,
    teamMembersNames,
    teamName,
    teamNumber,
  } = props

  const teamTitle = [
    `Equipe ${leftJustify(String(teamNumber), 3, '0')}`,
    teamName,
  ]
    .filter((str) => !validator.isEmpty(str))
    .join(' - ')

  const classes = useStyles()

  return (
    <ExpansionPanel expanded>
      <ExpansionPanelSummary className={classes.heading}>
        <Typography className={classes.headingTitle}>{teamTitle}</Typography>
      </ExpansionPanelSummary>

      {projectMadlib && (
        <ExpansionPanelDetails>
          <div className={classes.content}>
            <PanelField value={projectMadlib} />

            <PanelField value={projectCategory} title="Categoria do Desafio" />

            {teamMembersNames && (
              <PanelField title="Equipe" value={teamMembersNames} type="list" />
            )}

            {deckId && recordingId && (
              <div className={classes.player}>
                <TeamPlayer
                  authorizationToken={authorizationToken}
                  deckId={deckId}
                  recordingId={recordingId}
                />
              </div>
            )}
          </div>
        </ExpansionPanelDetails>
      )}
    </ExpansionPanel>
  )
}

TeamInfo.propTypes = {
  authorizationToken: PropTypes.string,
  deckId: PropTypes.number,
  projectCategory: PropTypes.string,
  projectMadlib: PropTypes.string,
  recordingId: PropTypes.number,
  teamMembersNames: PropTypes.arrayOf(PropTypes.string),
  teamName: PropTypes.string,
  teamNumber: PropTypes.number,
}
